import { gql } from '@apollo/client';

export const MONEY_OBJECT = gql`
    fragment MoneyObjectFields on ABMoney {
        centAmount
        currencyCode
        fractionDigits
    }
`;
